import type { ReportConfig } from '../ContributionMargin/liveModel';

import { completedMarketingRequest, transformMarketingCard } from './batches';

export const config: ReportConfig = {
  tablePageSize: { adgroup: 100, sales: 100 },
  transformRequest: completedMarketingRequest,
  transformCard: transformMarketingCard,
  viewFilters: {
    performance: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    attribution: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    pop: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    monthly: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    country: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    campaign: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    adgroup: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    segment: [
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
      'data_split_1',
      'data_split_2',
      'date_grain',
    ],
    sales: [
      'order_date_from',
      'order_date_to',
      'transaction_from',
      'transaction_to',
      'transaction_weekday',
      'data_split_1',
      'data_split_2',
      'date_grain',
      'attribution_model',
      'affiliate_partner',
      'brand_name',
      'category_name',
      'country_name',
      'customer_rar_type',
      'customer_type',
      'device_category',
      'gender',
      'geo_continent',
      'geo_country_name',
      'geo_region_name',
      'item_status',
      'luxplus_customer_flag',
      'mkt_campaign',
      'mkt_content',
      'mkt_medium',
      'mkt_source',
      'offer_bk',
      'offer_country_name',
      'offer_geo_area_level_1',
      'offer_name',
      'order_currency',
      'order_status',
      'order_with_car_hire',
      'order_with_experience',
      'order_with_flight',
      'order_with_insurance',
      'package_name',
      'product_name',
      'promo_applied',
      'reservation_type_name',
      'sale_type',
      'signup_tenure_band',
      'leadtime_band',
      'traffic_channel',
      'traffic_channel_detail',
      'vendor_name',
      'bod_sales',
      'mweb_sales',
    ],
  },
  splitDimensions: {
    sales: [
      'All',
      'affiliate_partner',
      'brand_name',
      'category_name',
      'country_name',
      'customer_rar_type',
      'customer_type',
      'device_category',
      'gender',
      'geo_continent',
      'geo_country_name',
      'geo_region_name',
      'item_status',
      'luxplus_customer_flag',
      'mkt_campaign',
      'mkt_content',
      'mkt_medium',
      'mkt_source',
      'offer_bk',
      'offer_country_name',
      'offer_geo_area_level_1',
      'offer_name',
      'order_currency',
      'order_status',
      'order_with_car_hire',
      'order_with_experience',
      'order_with_flight',
      'order_with_insurance',
      'package_name',
      'product_name',
      'promo_applied',
      'reservation_type_name',
      'sale_type',
      'signup_tenure_band',
      'leadtime_band',
      'traffic_channel',
      'traffic_channel_detail',
      'vendor_name',
      'bod_sales',
      'mweb_sales',
    ],
    media: [
      'All',
      'campaign_bk',
      'adgroup_bk',
      'adgroup_name',
      'publisher_platform',
      'platform_position',
      'campaign_name',
      'account',
      'campaign_status',
      'traffic_channel',
      'traffic_channel_detail',
      'channel',
      'country',
      'campaign_segment',
      'campaign_segment_perf_marketing',
      'effective_target_roas_source',
      'attribution_model',
      'marketing_router_id',
      'marketing_router_variant_id',
    ],
  },
  derived: {
    gm_after_discount: [
      [1, 'gm'],
      [-1, 'customer_discount'],
    ],
    gm_ar_after_discount: [
      [1, 'gm_ar'],
      [-1, 'customer_discount_ar'],
    ],
    sales_gm_ar: [
      [1, 'gm_br'],
      [-1, 'refund_ttv'],
      [1, 'vendor_holdback'],
    ],
    sales_ttv_ar: [
      [1, 'ttv_br'],
      [-1, 'refund_ttv'],
    ],
    refund_gm: [
      [1, 'refund_ttv'],
      [-1, 'vendor_holdback'],
    ],
  },
  parameters: { data_split_1: 'campaign_segment', data_split_2: 'All', date_grain: 'Daily' },
  pageId: 'performance-marketing',
  title: 'Performance Marketing',
  source: 'lux-analytics-prod.analytics.perf_mkt_reporting_roas',
  date: 'p_date',
  filters: [
    'order_date_from',
    'order_date_to',
    'transaction_from',
    'transaction_to',
    'transaction_weekday',
    'campaign_bk',
    'adgroup_bk',
    'adgroup_name',
    'publisher_platform',
    'platform_position',
    'campaign_name',
    'account',
    'campaign_status',
    'traffic_channel',
    'traffic_channel_detail',
    'channel',
    'country',
    'campaign_segment',
    'campaign_segment_perf_marketing',
    'effective_target_roas_source',
    'attribution_model',
    'marketing_router_id',
    'marketing_router_variant_id',
    'data_split_1',
    'data_split_2',
    'date_grain',
    'affiliate_partner',
    'brand_name',
    'category_name',
    'country_name',
    'customer_rar_type',
    'customer_type',
    'device_category',
    'gender',
    'geo_continent',
    'geo_country_name',
    'geo_region_name',
    'item_status',
    'luxplus_customer_flag',
    'mkt_campaign',
    'mkt_content',
    'mkt_medium',
    'mkt_source',
    'offer_bk',
    'offer_country_name',
    'offer_geo_area_level_1',
    'offer_name',
    'order_currency',
    'order_status',
    'order_with_car_hire',
    'order_with_experience',
    'order_with_flight',
    'order_with_insurance',
    'package_name',
    'product_name',
    'promo_applied',
    'reservation_type_name',
    'sale_type',
    'signup_tenure_band',
    'leadtime_band',
    'vendor_name',
    'bod_sales',
    'mweb_sales',
  ],
  defaultModel: 'Last Click 30D Non-Passive (excludes D,I,OS,PSB)',
  views: [
    {
      id: 'performance',
      label: 'Performance Marketing',
      card: 'summary',
      dimension: 'split_one',
      series: 'split_two',
    },
    {
      id: 'attribution',
      label: 'Attribution Model Comparison',
      card: 'attribution',
      dimension: 'attribution_model',
      series: 'traffic_channel',
    },
    {
      id: 'pop',
      label: 'PoP',
      card: 'summary',
      dimension: 'split_one',
      series: 'split_two',
    },
    { id: 'sales', label: 'Sales', card: 'sales_summary', dimension: 'split_one', series: 'split_two' },
    {
      id: 'monthly',
      label: 'Monthly',
      card: 'monthly',
      dimension: 'month',
      series: 'traffic_channel',
    },
    {
      id: 'country',
      label: 'Countries',
      card: 'country',
      dimension: 'country',
      series: 'traffic_channel',
    },
    {
      id: 'campaign',
      label: 'Campaigns',
      card: 'campaign',
      dimension: 'campaign_name',
      series: 'traffic_channel',
    },
    {
      id: 'adgroup',
      label: 'Ad groups',
      card: 'adgroup',
      dimension: 'adgroup_name',
      series: 'traffic_channel',
    },
    {
      id: 'segment',
      label: 'Segments',
      card: 'segment',
      dimension: 'campaign_segment_perf_marketing',
      series: 'traffic_channel',
    },
  ],
  primary: ['cost', 'gm', 'gm_ar', 'ttv', 'ttv_ar', 'orders'],
  ratios: {
    sessions_per_click: ['sessions', 'clicks'],
    platform_ttv_roas: ['conversions_value', 'cost'],
    new_buyer_gm_share: ['first_sale_gm', 'gm'],
    new_buyer_gm_ar_share: ['first_sale_gm_ar', 'gm_ar'],
    new_buyer_roas: ['first_sale_gm', 'cost'],
    new_buyer_roas_ar: ['first_sale_gm_ar', 'cost'],
    roas_after_discount: ['gm_after_discount', 'cost'],
    roas_ar_after_discount: ['gm_ar_after_discount', 'cost'],
    sales_orders_per_customer_all: ['orders_all', 'customers_all'],
    sales_aom_br: ['gm_br', 'orders_br'],
    sales_aov_br: ['ttv_br', 'orders_br'],
    sales_margin_rate_br: ['gm_br', 'ttv_br'],
    sales_orders_per_customer: ['orders_br', 'customers_br'],
    sales_items_per_order: ['items_br', 'orders_br'],
    sales_leadtime_br: ['leadtime_br_total', 'leadtime_br_known'],
    sales_leadtime: ['leadtime_total', 'leadtime_known'],
    sales_session_order_days: ['session_order_days_total', 'session_order_days_known'],
    sales_refund_rate: ['refund_gm', 'gm_br'],
    sales_new_customer_gm_share: ['first_sale_margin', 'gm_br'],
    margin_roas: ['gm', 'cost'],
    margin_roas_ar: ['gm_ar', 'cost'],
    ttv_roas: ['ttv', 'cost'],
    ttv_roas_ar: ['ttv_ar', 'cost'],
    cpc: ['cost', 'clicks'],
    ctr: ['clicks', 'impressions'],
    cost_per_order: ['cost', 'orders'],
    cost_per_signup: ['cost', 'sign_ups'],
    click_conversion: ['orders', 'clicks'],
    session_conversion: ['orders', 'sessions'],
    bounce_rate: ['bounces', 'sessions'],
    ltle_order_share: ['ltle_orders', 'orders'],
    lpp_order_share: ['lpp_orders', 'orders'],
    lpc_order_share: ['lpc_orders', 'orders'],
    target_roas: ['target_roas_weighted', 'target_roas_cost'],
    effective_target_roas: ['effective_target_roas_weighted', 'effective_target_roas_cost'],
    search_top_share: ['search_top_weighted', 'search_top_impressions'],
    search_absolute_top_share: ['search_absolute_top_weighted', 'search_absolute_top_impressions'],
  },
  definitions: {
    sales_gm_ar_share:
      'GM AR / sum of GM AR across every complete selected split group, independently per period. Decimal share; zero denominator is Unknown. Original Sales All PctTotal partition still requires visible/export reconciliation.',
    sales_dates:
      'Transaction datetime bounds are inclusive Sydney civil timestamps within the selected period; order-date bounds are optional inclusive UTC calendar dates. Weekday uses the transaction Sydney calendar.',
    custom_comparison:
      'Custom comparison uses its explicit inclusive bounds. Last Year shifts each bound independently. Optional Sales filters apply to both periods.',
    cost: 'AUD spend repeats per attribution model. Never sum or compare totals across models.',
    margin_roas: 'Aggregate GM BR / aggregate media cost; AR is separate.',
    orders: 'Fractional attribution credit; product orders overlap. Product shares need not sum to100%.',
    sign_ups: 'Website sign-ups, not acquired customers; CAC is unavailable.',
    router: 'Router variant cost/clicks/impressions use source session-proportional allocation.',
    target_roas:
      'Cost-weighted target; search shares impression-weighted. Exact workbook partition parity requires verification.',
  },
  limitations: [
    'Current source XML rev15.4 and the recovered main, attribution and PoP views have been inspected; full numeric parity for every original view remains under verification.',
    'Sales reads analytics.sales_attribution with source COUNTD customers/orders and separate transaction/filter semantics; original CSV and complete filter/default parity remain under verification.',
    'Original Today timezone, evaluated date, BoD/MWEB selection and visible transaction timestamp extent versus hard filter remain unresolved; native optional bounds never infer that saved scope.',
    'Original PoP discount calculations contain cross-wired BR/AR aliases; recovered ordinary discount metrics follow their separate main-view definitions. Exact source PoP alias behaviour is not certified.',
    'Attribution comparison repeats spend per model; no cross-model totals are computed.',
    'Weekly edge buckets may be partial. Non-additive ratios use aggregate components.',
  ],
};
